export const MESSAGE_DIVIDER = "<$$NEXT_MESSAGE$$>";
export const ID_DIVIDER = "<$$$$>";
export const SIMPLE_INLINE_DIVIDER = ","
export const SIMPLE_MESSAGE_DIVIDER = "|";